<template>
  <div class="relative h-full ml-1 mr-1 lg:mr-4">
    <button
      class="flex items-center justify-center h-full text-black no-underline transition-all"
      id="btn-cart"
      data-testid="btn-cart"
      @click.prevent="handleClick"
      :title="$t('cart.title')"
    >
      <div class="relative h-6">
        <CartIcon />
        <div
          v-if="cartCount"
          class="bg-br-green min-w-[1.25rem] p-1 scale-75 color absolute flex items-center justify-center h-4 fluid-xs leading-tightest font-medium -top-1.5 -right-1.5"
        >
          <span class="text-white">
            {{ cartCount }}
          </span>
        </div>
      </div>
    </button>
  </div>
</template>

<script setup>
import CartIcon from '@/components/icons/CartIcon';
import { useCartStore } from '@/stores/cart';
import { storeToRefs } from 'pinia';

const cartStore = useCartStore();
const { lineItems, cartCount } = storeToRefs(cartStore);

const handleClick = () => {
  cartStore.open();
};
</script>
